var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class ThemeEvents {
}
/** @static @constant {string} Event triggered when a media (video, 3d model) is loaded */
__publicField(ThemeEvents, "mediaStartedPlaying", "media:started-playing");
// Event triggered when quantity-selector value is changed
__publicField(ThemeEvents, "quantitySelectorUpdate", "quantity-selector:update");
/** @static @constant {string} Event triggered when a predictive search is expanded */
__publicField(ThemeEvents, "megaMenuHover", "megaMenu:hover");
/** @static @constant {string} Event triggered when a zoom dialog media is selected */
__publicField(ThemeEvents, "zoomMediaSelected", "zoom-media:selected");
class QuantitySelectorUpdateEvent extends Event {
  /**
   * Creates a new QuantitySelectorUpdateEvent
   * @param {number} quantity - Quantity value
   * @param {number} [cartLine] - The id of the updated cart line
   */
  constructor(quantity, cartLine) {
    super(ThemeEvents.quantitySelectorUpdate, { bubbles: true });
    this.detail = {
      quantity,
      cartLine
    };
  }
}
class MediaStartedPlayingEvent extends Event {
  /**
   * Creates a new MediaStartedPlayingEvent
   * @param {HTMLElement} resource - The element containing the video that emitted the event
   */
  constructor(resource) {
    super(ThemeEvents.mediaStartedPlaying, { bubbles: true });
    this.detail = {
      resource
    };
  }
}
const _SlideshowSelectEvent = class _SlideshowSelectEvent extends Event {
  /**  @param {SlideshowSelectEventData} data */
  constructor(data) {
    super(_SlideshowSelectEvent.eventName, { bubbles: true });
    /** @type {SlideshowSelectEventData} */
    __publicField(this, "detail");
    this.detail = data;
  }
};
__publicField(_SlideshowSelectEvent, "eventName", "slideshow:select");
let SlideshowSelectEvent = _SlideshowSelectEvent;
class ZoomMediaSelectedEvent extends Event {
  /**
   * Creates a new ZoomMediaSelectedEvent
   * @param {number} index - The index of the selected media
   */
  constructor(index) {
    super(ThemeEvents.zoomMediaSelected, { bubbles: true });
    this.detail = {
      index
    };
  }
}
class MegaMenuHoverEvent extends Event {
  constructor() {
    super(ThemeEvents.megaMenuHover, { bubbles: true });
  }
}
export {
  MediaStartedPlayingEvent,
  MegaMenuHoverEvent,
  QuantitySelectorUpdateEvent,
  SlideshowSelectEvent,
  ThemeEvents,
  ZoomMediaSelectedEvent
};
